const ContactHero = () => {
  return (
    <section className="relative bg-navy py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 30px, #D4AF37 30px, #D4AF37 31px), repeating-linear-gradient(-45deg, transparent, transparent 30px, #D4AF37 30px, #D4AF37 31px)',
        }}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6">GET IN TOUCH</h1>
        <div className="h-1 w-32 bg-gold mx-auto mb-6"></div>
        <p className="text-gray-300 text-lg">
          Request a quote or discuss your commercial electrical project with our experienced team
        </p>
      </div>
    </section>
  );
};

export default ContactHero;